export const CLOUD_ACCOUNT = {
  AWS: 'aws',
  AZURE: 'azure',
  GCP: 'gcp'
};